import { Routes, Route } from 'react-router-dom';
import UserList from './UserList';
import UserCreate from './UserCreate';
import UserDetail from './UserDetail';

/**
 * 用户管理子模块路由。列表 / 新建 / 详情均为模块内部路由，
 * 对外只暴露挂载点 `/iam/users/*`，App.tsx 无需感知内部结构。
 */
export default function IamUsersRoutes() {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path="create" element={<UserCreate />} />
      <Route path=":id" element={<UserDetail />} />
    </Routes>
  );
}
